import { useEffect, useState } from "react";

/** Debounce a fast-changing value (e.g. search keystrokes) so effects/API calls fire once the user pauses. */
export function useDebouncedValue(value, delay = 400) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}
